import {defaults, assign} from 'lodash';
import * as slider from '../logic/slider';

export const pickerDragStart = (state, coordinates, diameter = 0) => {
  return defaults(
    {
      x: slider.dragStart(state.x, coordinates, diameter),
      y: slider.dragStart(state.y, coordinates, diameter),
    },
    state
  );
};

export const pickerDrag = (state, coordinates, diameter = 0) => {
  return defaults(
    {
      x: slider.drag(state.x, coordinates, diameter),
      y: slider.drag(state.y, coordinates, diameter),
    },
    state
  );
};

export const pickerDragEnd = (state) => {
  return defaults(
    {
      x: slider.dragEnd(state.x),
      y: slider.dragEnd(state.y),
    },
    state
  );
};

export const getInitialState = (props) => {
  return {
    x: assign(
      slider.getInitialState({}),
      props.x,
      props.width ? {length: props.width} : {}
    ),
    y: assign(
      slider.getInitialState({vertical: true}),
      props.y,
      props.height ? {length: props.height} : {}
    ),
  };
};
